import { MD5 } from 'crypto-js'
import { acceptHMRUpdate, defineStore } from 'pinia'
import { useConfigStore } from './ConfigStore'

type AmplitudeProperty = string | number | boolean | null

type AmplitudeEvent = {
  user_id?: string
  device_id?: string
  event_type: string
  timestamp: number
  event_properties?: Record<string, AmplitudeProperty>
  user_properties?: Record<string, AmplitudeProperty>
  groups?: Record<string, string>
  group_properties?: Record<string, AmplitudeProperty>
}

type TState = {
  events: AmplitudeEvent[]
}

const initialState: TState = {
  events: [],
}

const useAmplitudeStore = defineStore('amplitudeStore', {
  state: () => {
    return { ...initialState }
  },

  actions: {
    addEvent(event: AmplitudeEvent) {
      this.events.push(event)
    },
    addAppClosedEvent(employee_id: number) {
      this.addEvent({
        user_id: MD5(employee_id.toString()).toString(),
        event_type: 'App Closed',
        timestamp: Date.now(),
      })
    },
    addAppOpenedEvent(employee_id: number) {
      this.addEvent({
        user_id: MD5(employee_id.toString()).toString(),
        event_type: 'App Opened',
        timestamp: Date.now(),
      })
    },

    sync() {
      return this._send()
    },

    async _send() {
      const apiKey = useConfigStore().amplitude_api_key
      if (!apiKey) return
      let response = null
      await fetch('https://api.eu.amplitude.com/2/httpapi', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          api_key: apiKey,
          events: this.events,
        }),
      })
        .then((res) => {
          response = res
          if (res.status === 200) {
            this.events = []
          } else if (this.events.length > 200) {
            this.events = []
          }
        })
        .catch((err) => {
          console.log(err)
          if (this.events.length > 200) {
            this.events = []
          }
        })
      return response
    },
    hydrate(state: string) {
      this.$state = JSON.parse(state)
    },
  },
})

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useAmplitudeStore, import.meta.hot))
}

export { useAmplitudeStore }
